<template>
  <el-dialog
    :close-on-click-modal="false"
    title="设置承诺发货时间"
    :visible.sync="visible"
    width="540px"
    class="remarkDialog"
    :before-close="handleClose"
  >
    <!-- -->
    <el-form :model="detail" ref="form" label-width="120px">
      <el-form-item label="发货时间：">
        <el-date-picker
          v-model="latestShipDate"
          type="datetime"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="tip"></div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small"> 保存 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { editOrder } from "@/api/order/all"
import { mapGetters } from "vuex"

export default {
  name: "SetSendTime",
  data() {
    return {
      allTotal: 0,
      detail: { currency: "", saleTotal: "", saleFare: "", saleDiscount: "" },
      latestShipDate: "",
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    orderData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    orderData() {
      this.allTotal = this.orderData.saleActPay
      this.latestShipDate = ""
      this.detail = this._.clone(
        this._.pick(
          this.orderData,
          "currency",
          "saleTotal",
          "saleFare",
          "saleDiscount",
          "appId",
          "latestShipDate"
        )
      )
      if(this.detail.latestShipDate){
        this.latestShipDate = new Date(this.detail.latestShipDate)
      }
    },
  },
  methods: {
    sure() {
      if (!this.latestShipDate) {
        this.$message.error("请选择发货时间")
        return
      }
      editOrder({
        appId: this.detail.appId,
        latestShipDate: this.latestShipDate,
      }).then((res) => {
        if (res.code !== 200) {
          this.$message.error("修改失败")
        } else {
          this.$message.success("修改成功")
          this.$emit("onOk")
        }
      })
    },
    handleClose() {
      this.$emit("onClose")
    },
  },
}
</script>

<style scoped>
.remarkDialog {
  font-size: 12px;
}

.item {
  display: flex;
  flex-wrap: wrap;
}

.tip {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
}

.tip .store-info-icon {
  display: inline-block;
  padding: 0 0 0 5px;
  background: #129ba7;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 1.4;
}

.blue {
  color: #129ba7;
}
</style>
